<template>
  <div>
    <a-card title="业主缴费查询">
      <p class="hint muted">按<strong>实际录入系统时间</strong>查询「财务专用缴费查询」中手工录入的充值/退款记录。</p>
      <a-form layout="inline" class="filter-form">
        <a-form-item label="开始日期">
          <a-date-picker v-model="startDate" valueFormat="YYYY-MM-DD" placeholder="开始日期" />
        </a-form-item>
        <a-form-item label="结束日期">
          <a-date-picker v-model="endDate" valueFormat="YYYY-MM-DD" placeholder="结束日期" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" :loading="loading" @click="onQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="onReset">重置</a-button>
        </a-form-item>
        <a-form-item class="total-amount-item">
          <span class="total-amount-text">
            总计金额：<strong>¥{{ formatAmount(totalAmount) }}</strong>
          </span>
        </a-form-item>
      </a-form>

      <a-table
        style="margin-top: 16px"
        size="small"
        :columns="columns"
        :dataSource="items"
        rowKey="id"
        :loading="loading"
        :pagination="pagination"
        @change="tableChange"
      />
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import { manualEntryRecordsList } from '@/api/ownerPayment'

export default {
  name: 'OwnerPaymentQuery',
  data() {
    return {
      startDate: null,
      endDate: null,
      items: [],
      totalAmount: 0,
      loading: false,
      page: 1,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (t) => `共 ${t} 条`,
      },
      columns: [
        { title: '楼号', dataIndex: 'building_no', key: 'building_no', customRender: (t) => t || '-' },
        { title: '房号', dataIndex: 'unit_no', key: 'unit_no', customRender: (t) => t || '-' },
        { title: '姓名', dataIndex: 'owner_name', key: 'owner_name' },
        {
          title: '金额',
          dataIndex: 'amount',
          key: 'amount',
          customRender: (t) => (t != null ? `¥${Number(t).toFixed(2)}` : '-'),
        },
        { title: '业务日期', dataIndex: 'business_date', key: 'business_date' },
        { title: '录入时间', dataIndex: 'entered_at', key: 'entered_at', width: 150, customRender: (t) => t || '-' },
        { title: '备注', dataIndex: 'remark', key: 'remark', ellipsis: true, customRender: (t) => t || '-' },
      ],
    }
  },
  methods: {
    onQuery() {
      if (!this.startDate || !this.endDate) {
        this.$message.warning('请选择开始日期与结束日期')
        return
      }
      if (moment(this.startDate).isAfter(moment(this.endDate))) {
        this.$message.warning('开始日期不能晚于结束日期')
        return
      }
      this.page = 1
      this.pagination.current = 1
      this.fetchList()
    },
    onReset() {
      this.startDate = null
      this.endDate = null
      this.items = []
      this.totalAmount = 0
      this.page = 1
      this.pagination.current = 1
      this.pagination.total = 0
    },
    fetchList() {
      if (!this.startDate || !this.endDate) return
      this.loading = true
      manualEntryRecordsList({
        start_date: this.startDate,
        end_date: this.endDate,
        page: this.page,
        page_size: this.pagination.pageSize,
      })
        .then((data) => {
          this.pagination.total = data.count || 0
          this.items = data.results || []
          this.totalAmount = Number(data.total_amount || 0)
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    tableChange(pag) {
      this.page = pag.current
      this.pagination.current = pag.current
      if (pag.pageSize !== this.pagination.pageSize) {
        this.pagination.pageSize = pag.pageSize
        this.page = 1
        this.pagination.current = 1
      }
      if (this.startDate && this.endDate) {
        this.fetchList()
      }
    },
    formatAmount(amount) {
      return Number(amount || 0).toFixed(2)
    },
  },
}
</script>

<style scoped>
.hint {
  margin-bottom: 12px;
}
.filter-form {
  margin-bottom: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.total-amount-item {
  margin-left: auto;
}
.total-amount-text {
  font-size: 14px;
}
</style>
